/* eslint-disable no-undef */
export default {
	name: "password-generator-modal",
	props: ["modalId", "userId", "showModal", "username", "reset"],
	emits: ["passwordGeneratorOkClicked"],
	data() {
		return {
			idForModal: null,
			password: null,
			passwordHasError: false,
			passwordErrorMessage: null,
			passwordGenerator:{
				length: 8,
				lowercaseCharacters: true,
				uppercaseCharacters: true,
				numbers: true,
				symbols: true,
				excludeSimilarCharacters: true,
				excludeAmbiguousCharacters: true
			},
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		generatePassword(){
			var request = {
				length: this.passwordGenerator.length,
				useLowercaseLetters: this.passwordGenerator.lowercaseCharacters,
				useUppercaseLetters: this.passwordGenerator.uppercaseCharacters,
				useNumbers: this.passwordGenerator.numbers,
				useSymbols: this.passwordGenerator.symbols,
				excludeSimilarCharacters: this.passwordGenerator.excludeSimilarCharacters,
				excludeAmbiguousCharacters: this.passwordGenerator.excludeAmbiguousCharacters
			};
			securityService.generatePassword(request).then(
				successResponse => {
					var isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.password = successResponse.data.password;
					}
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onNumbersForPasswordChange(){
			this.generatePassword();
		},
		onPasswordLengthChange(){
			if(this.passwordGenerator.length < 8){
				this.passwordGenerator.length = 8;
			}
			this.generatePassword();
		},
		onLowercaseLettersForPasswordChange(){
			this.generatePassword();
		},
		onUppercaseLettersForPasswordChange(){
			this.generatePassword();
		},
		onSymbolsForPasswordChange(){
			this.generatePassword();
		},
		onExcludeSimilarCharactersForPasswordChange(){
			this.generatePassword();
		},
		onExcludeAmbiguousCharactersForPasswordChange(){
			this.generatePassword();
		},
		clearMessageAlerts(){
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;

			this.$emit("passwordGeneratorOkClicked", true);
		},
		resetUserPassword(){
			this.loading = true;
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;
			let request = {
				userId: this.userId,
				password: this.password
			};

			securityService.resetPassword(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.passwordValidationResponse.hasError){
							this.passwordHasError = true;
							this.passwordErrorMessage = successResponse.data.passwordValidationResponse.message;
						}
						else{
							this.showSuccessMessage = true;
							this.successMessage = "Password reset successfully";
						}
						
						//this.$emit("completedPasswordReset", true);
					}
					else{
						this.showErrorMessage = true;
						this.errorMessage = "Failed to reset password";
						//this.$emit("completedPasswordReset", false);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.showErrorMessage = true;
					this.errorMessage = "Failed to reset password";
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
	},
	computed: {
        
	},
	mounted: function () {
	},
	unmounted: function() {
		this.passwordGenerator = {
			length: 8,
			lowercaseCharacters: true,
			uppercaseCharacters: true,
			numbers: true,
			symbols: true,
			excludeSimilarCharacters: true,
			excludeAmbiguousCharacters: true
		};
	},
	watch: {
		userId: {
			handler: function () {
				console.log("userId", this.userId);
				this.generatePassword();
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				this.idForModal = this.modalId;
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				console.log("showModal", this.showModal);
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		reset: {
			handler: function () {
				if(this.reset){
					this.passwordGenerator ={
						length: 8,
						lowercaseCharacters: true,
						uppercaseCharacters: true,
						numbers: true,
						symbols: true,
						excludeSimilarCharacters: true,
						excludeAmbiguousCharacters: true
					};
				}
			},
			immediate: true,
			deep: true
		}
	}
};